import { type FC } from 'react'
import { UpsellBodyLayout } from '../../Common/UpsellBodyLayout'
import { UpsellFeatureItem } from '../../Common/UpsellFeatureItem'
import InboxPromo from '../../../../assets/images/promo-inbox.png'

import './InboxUpsell.scss'

export const InboxUpsellBody: FC = () => {
  return (
    <UpsellBodyLayout
      image={
        <a href='https://youtu.be/0vF8GGSg3Bk' target='_blank' rel='noopener noreferrer'>
          <img src={InboxPromo} alt='Watch inbox demo' className='zocks-border-0.5 inbox-upsell-promo' />
        </a>
      }
      heading={
        <>
          Save hours on emails with <span className='zocks-text-primary'>Inbox</span>
        </>
      }
      description='Turn your overwhelming inbox into a productivity powerhouse with AI that works exactly how you do.'
    />
  )
}

export const InboxUpsellFeatures: FC = () => {
  return (
    <>
      <UpsellFeatureItem title='Smart Email Categorization' description='Automatically categorize emails and get the perfect response template' />
      <UpsellFeatureItem title='Contextual Intelligence' description='Get personalized, compliant drafts with CRM and meeting context' />
      <UpsellFeatureItem
        title='Automatic client profile updates'
        description='Detect and sync life events and financial changes across your wealth stack'
        className='mb-3'
      />
    </>
  )
}
